import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import asyncComponent from "util/asyncComponent";
import Verification from "../UserPanel/verification/verification.index";
import CEUser from "./user/user.index";
import CEBlackList from './blacklist/index'
import Confirmverification from "./confirmverification/index";
import ConfirmVerificationDetail from "./confirmVerficationDetail/confirmVerficationdDetail.index";
import AdminTicket from "./adminticket/index";
import AdminTicketDetail from "./adminticketdetail/index";
import OrderHistory from "../UserPanel/orderhistory";
import Balance from "./balance/balance.index";
import Content from "./content/content.index";
import UpdateContent from "./content/update/updateContent.index";
import UserDetail from "./userDetail/userDetail.index";
import OrderDetail from "./orderDetail/orderDetail.index";
import { checkIsLogin } from "../index";
function checkIsAdmin()
{
    return (
        checkIsLogin() &&
        (localStorage.getItem("roles").includes("Admin") ||
            localStorage.getItem("roles").includes("ConfirmationSupport") ||
            localStorage.getItem("roles").includes("OrderSupportLevelOne") ||
            localStorage.getItem("roles").includes("OrderSupportLeveTwo") ||
            localStorage.getItem("roles").includes("AnswerSupport"))
    );
}

const Admin = ({ match }) => (
    <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/cc`} />
        <Route
            path={`${match.url}/cc`}
            component={
                checkIsAdmin()
                    ? asyncComponent(() => import("./cc"))
                    : window.location.replace("/authorization/")
            }
        />

        <Route
            exact
            path={`${match.url}/blacklistmanagement/blockedItem/:id?`}
            component={CEBlackList}
        />
        <Route
            path={`${match.url}/blacklistmanagement`}
            component={asyncComponent(() => import("./blacklistmanagement"))}
        />
        <Route
            path={`${match.url}/payment`}
            component={asyncComponent(() => import("./payment"))}
        />
        <Route
            path={`${match.url}/carts`}
            component={asyncComponent(() => import("./carts"))}
        />
        <Route
            exact
            path={`${match.url}/usermanagement/user/:id?`}
            component={CEUser}
        />
        <Route
            exact
            path={`${match.url}/usermanagement`}
            component={asyncComponent(() => import("./usermanagement"))}
        />
        <Route
            exact
            path={`${match.url}/userdetail/:id`}
            component={UserDetail}
        />
        <Route
            exact
            path={`${match.url}/confirmverification/detail/:id?`}
            component={ConfirmVerificationDetail}
        />
        <Route
            exact
            path={`${match.url}/confirmverification`}
            component={Confirmverification}
        />
        <Route
            exact
            path={`${match.url}/ticket/detail/:id`}
            component={AdminTicketDetail}
        />
        <Route exact path={`${match.url}/ticket`} component={AdminTicket} />
        <Route path={`${match.url}/orderhistory`}>
            <OrderHistory isAdmin={true} />
        </Route>

        <Route
            exact
            path={`${match.url}/content/update/:id`}
            component={UpdateContent}
        />

        <Route path={`${match.url}/content`} component={Content} />

        <Route path={`${match.url}/balance`} component={Balance} />
    </Switch>
);

export default Admin;
